@if (isVisible$ | async) {
  <div class="maintenance-banner">
    <ion-icon name="construct-outline"></ion-icon>
    Wartungsarbeiten laufen, es kann zu Darstellungsfehlern kommen.
  </div>
}
